import { create } from 'zustand';

/**
 * App-wide UI state. Currently just tracks the mobile sidebar drawer.
 *
 * The Zustand store stays here in the app, and `@my/ui/DashboardLayout` only
 * sees `isOpen` / `onToggle` props — keeping the layout logic decoupled from
 * any specific state library.
 */
interface UiState {
  isSidebarOpen: boolean;
  openSidebar: () => void;
  closeSidebar: () => void;
  toggleSidebar: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  isSidebarOpen: false,
  openSidebar: () => set({ isSidebarOpen: true }),
  closeSidebar: () => set({ isSidebarOpen: false }),
  toggleSidebar: () => set((s) => ({ isSidebarOpen: !s.isSidebarOpen })),
}));
